<app-application-steps [showTechnicalFormFirst]="true" [currentStep]="step" [isDetailsView]="isDetailsView"></app-application-steps>

<div class="component-container" id="print-form">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'grid-comp.tech-form-title' | translate }}
      <span *ngIf="isDetailsView">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'app.navigation.tech_data' | translate }}
    </div>
  </div>

  <div *ngIf="isLoading" class="loader-container">
    <div class="loader-overlay">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>

  <div *ngIf="!isLoading" class="technical-data-form-container">
    <form #technicalForm="ngForm" class="form-section form-font-size">
      <!-- BASE DATA -->
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <div class="margin-header-align section-heading text-uppercase">
          <div class="ui-g-12">
            <app-section-header
              [title]="'grid-comp.base-data' | translate"
              [tooltip]="'tooltips.technical-data.grid-comp.base-data' | translate"></app-section-header>
          </div>
          <div class="section-buttons">
            <lock-unlock-buttons
              [showLockButton]="isDetailsView"
              [showUnlockButton]="isDetailsView"
              [isLocked]="technicalData.technical_specifications_sections_state?.is_base_data_locked"
              [formName]="TechnicalSpecificationsFormSections.BaseData"
              [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
              (lockButtonClickedEvent)="lockSection($event)"
              (unLockButtonClickedEvent)="unlockSection($event)"></lock-unlock-buttons>
            <i
              *ngIf="isDetailsView"
              class="pi pi-comment"
              [ngClass]="
                isBaseDataCommentVisible || technicalData.technical_specifications_sections_state?.base_data_comment
                  ? 'lock-icon-style'
                  : 'unlock-icon-style'
              "
              [pTooltip]="
                (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                isBaseDataCommentVisible ||
                technicalData.technical_specifications_sections_state?.base_data_comment
                  ? ('comment-section.comment-tooltip' | translate)
                  : null
              "
              [tooltipPosition]="
                (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                isBaseDataCommentVisible ||
                technicalData.technical_specifications_sections_state?.base_data_comment
                  ? 'bottom'
                  : null
              "
              (click)="showComment(TechnicalSpecificationsFormSections.BaseData)"></i>
          </div>
        </div>
      </div>
      <section-comment
        [isCommentTextInputVisible]="
          isModeratorRole() && (isBaseDataCommentVisible || technicalData.technical_specifications_sections_state?.base_data_comment)
        "
        [isCommentTextVisible]="role !== 'employee' && role !== 'administrator'"
        [isCommentSaveVisible]="!technicalData.technical_specifications_sections_state?.base_data_comment"
        [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
        [comment]="technicalData.technical_specifications_sections_state?.base_data_comment"
        [formName]="TechnicalSpecificationsFormSections.BaseData"
        (saveCommentEvent)="updateComment($event)"
        (deleteCommentEvent)="deleteComment($event)"></section-comment>
      <div
        data-testId="base-data"
        class="section-wrapper margin-align"
        [ngClass]="
          technicalData.technical_specifications_sections_state?.is_base_data_locked !== true || !applicationId ? '' : 'disable-section'
        ">
        <div class="section-column">
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.producer-type' | translate }}
            </label>
            <p-dropdown
              class="form-control"
              [options]="typesOfEnergyProducers"
              [(ngModel)]="technicalData.existing_energy_producers[0].energy_type"
              (ngModelChange)="setEnergySource(technicalData.existing_energy_producers[0])"
              optionValue="value"
              placeholder="Please select"
              name="energy_type"
              #energy_type="ngModel"
              required
              [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
              [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
              [disabled]="isEditableByExternalRoles() || isBaseDataDisabled()"></p-dropdown>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.source-type' | translate }}
            </label>
            <p-dropdown
              class="form-control"
              [options]="getEnergySources(technicalData.existing_energy_producers[0])"
              [(ngModel)]="technicalData.existing_energy_producers[0].energy_source"
              optionValue="value"
              placeholder="Please select"
              name="energy_source"
              #energy_source="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-dropdown>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.producer-total-power' | translate }}
            </label>
            <p-inputNumber
              class="form-control"
              [(ngModel)]="technicalData.existing_energy_producers[0].total_feed_in_power"
              name="total_feed_in_power"
              (ngModelChange)="setupGridProtectionDocuments()"
              (keydown)="detectDecimalSeparator($event)"
              #total_feed_in_power="ngModel"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
              locale="de-DE"
              required
              [disabled]="isBaseDataDisabled()"></p-inputNumber>
            <label class="ml-2">kW</label>
          </div>
          <div
            *ngIf="
              technicalData.existing_energy_producers[0].energy_type === ENERGY_TYPES.OTHER ||
              technicalData.existing_energy_producers[0].energy_source === ENERGY_SOURCES.OTHER
            ">
            <div class="section-field">
              <label *ngIf="technicalData.existing_energy_producers[0].energy_type === ENERGY_TYPES.OTHER" class="ui-g-5 required">
                {{ 'grid-comp.other-producer' | translate }}
              </label>
              <input
                class="form-control"
                *ngIf="technicalData.existing_energy_producers[0].energy_type === ENERGY_TYPES.OTHER"
                type="text"
                pInputText
                [(ngModel)]="technicalData.existing_energy_producers[0].other_energy_type"
                name="other_energy_type"
                #other_energy_type="ngModel"
                required
                [disabled]="isBaseDataDisabled()" />
            </div>
            <div class="section-field">
              <label *ngIf="technicalData.existing_energy_producers[0].energy_source === ENERGY_SOURCES.OTHER" class="ui-g-5 required">
                {{ 'grid-comp.other-source' | translate }}
              </label>
              <input
                class="form-control"
                *ngIf="technicalData.existing_energy_producers[0].energy_source === ENERGY_SOURCES.OTHER"
                type="text"
                pInputText
                [(ngModel)]="technicalData.existing_energy_producers[0].other_energy_source"
                name="other_energy_source"
                #other_energy_source="ngModel"
                required
                [disabled]="isBaseDataDisabled()" />
            </div>
          </div>
          <div *ngIf="this.technicalData.existing_energy_producers[0].energy_type !== ENERGY_TYPES.STORAGE">
            <div class="section-field">
              <label class="ui-g-5 required">
                {{ 'grid-comp.contain-storage' | translate }}
              </label>
              <p-radioButton
                name="has_power_storage"
                [value]="true"
                label="{{ 'grid-comp.yes' | translate }}"
                class="mr-2"
                (ngModelChange)="hasPowerStorageChange($event)"
                [(ngModel)]="technicalData.has_power_storage"
                #has_power_storage="ngModel"
                required
                [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
                [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
                [disabled]="isEditableByExternalRoles() || isBaseDataDisabled()"></p-radioButton>
              <p-radioButton
                name="has_power_storage"
                [value]="false"
                label="{{ 'grid-comp.no' | translate }}"
                (ngModelChange)="hasPowerStorageChange($event)"
                [(ngModel)]="technicalData.has_power_storage"
                #has_power_storage2="ngModel"
                required
                [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
                [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
                [disabled]="isEditableByExternalRoles() || isBaseDataDisabled()"></p-radioButton>
            </div>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.existing-producer' | translate }}
            </label>
            <p-radioButton
              name="has_energy_producer"
              [value]="true"
              label="{{ 'grid-comp.yes' | translate }}"
              class="mr-2"
              [(ngModel)]="technicalData.has_energy_producer"
              #has_energy_producer="ngModel"
              (ngModelChange)="hasEnergyProducerChange($event)"
              required
              [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
              [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
              [disabled]="isEditableByExternalRoles() || isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="has_energy_producer"
              [value]="false"
              label="{{ 'grid-comp.no' | translate }}"
              [(ngModel)]="technicalData.has_energy_producer"
              #has_energy_producer="ngModel"
              (ngModelChange)="hasEnergyProducerChange($event)"
              required
              [pTooltip]="isEditableByExternalRoles() ? ('grid-comp.disabled-field-tooltip' | translate) : null"
              [tooltipPosition]="isEditableByExternalRoles() ? 'bottom' : null"
              [disabled]="isEditableByExternalRoles() || isBaseDataDisabled()"></p-radioButton>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.feed-in-type' | translate }}
            </label>
            <p-radioButton
              name="electrical_feed_type"
              value="singlePhase"
              class="mr-2"
              label="{{ 'grid-comp.single-phase' | translate }}"
              [(ngModel)]="technicalData.electrical_feed_type"
              #electrical_feed_type="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="electrical_feed_type"
              value="twoPhase"
              class="mr-2"
              label="{{ 'grid-comp.two-phase' | translate }}"
              [(ngModel)]="technicalData.electrical_feed_type"
              #electrical_feed_type="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="electrical_feed_type"
              value="threePhase"
              class="mr-2"
              label="{{ 'grid-comp.three-phase' | translate }}"
              [(ngModel)]="technicalData.electrical_feed_type"
              #electrical_feed_type="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="electrical_feed_type"
              value="threePhaseAcCurrent"
              label="{{ 'grid-comp.three-phase-ac' | translate }}"
              [(ngModel)]="technicalData.electrical_feed_type"
              #electrical_feed_type="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.black-start' | translate }}
            </label>
            <p-radioButton
              name="black_start_capability"
              value="true"
              class="mr-2"
              label="{{ 'grid-comp.yes' | translate }}"
              [(ngModel)]="technicalData.black_start_capability"
              #black_start_capability="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="black_start_capability"
              value="false"
              label="{{ 'grid-comp.no' | translate }}"
              [(ngModel)]="technicalData.black_start_capability"
              #black_start_capability="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.isolated-operation' | translate }}
            </label>
            <p-radioButton
              name="io_planned"
              value="true"
              [(ngModel)]="technicalData.io_planned"
              class="mr-2"
              label="{{ 'grid-comp.yes' | translate }}"
              #io_planned="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="io_planned"
              value="false"
              [(ngModel)]="technicalData.io_planned"
              label="{{ 'grid-comp.no' | translate }}"
              #io_planned="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.engine-supported-start' | translate }}
            </label>
            <p-radioButton
              name="ess_planned"
              value="true"
              [(ngModel)]="technicalData.ess_planned"
              class="mr-2"
              label="{{ 'grid-comp.yes' | translate }}"
              #ess_planned="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
            <p-radioButton
              name="ess_planned"
              value="false"
              [(ngModel)]="technicalData.ess_planned"
              label="{{ 'grid-comp.no' | translate }}"
              #ess_planned="ngModel"
              required
              [disabled]="isBaseDataDisabled()"></p-radioButton>
          </div>
        </div>
      </div>
      <!-- BASE DATA -->

      <!-- EXISTING ENERGY PRODUCER -optional -->
      <div
        *ngIf="technicalData.has_energy_producer === true"
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <div class="margin-header-align section-heading text-uppercase">
          <div class="ui-g-12">
            <app-section-header
              [title]="'grid-comp.existing-producer-label' | translate"
              [tooltip]="'tooltips.technical-data.grid-comp.existing-producer' | translate"></app-section-header>
          </div>
          <div class="section-buttons">
            <lock-unlock-buttons
              [showLockButton]="isDetailsView"
              [showUnlockButton]="isDetailsView"
              [isLocked]="technicalData.technical_specifications_sections_state?.is_existing_energy_producer_locked"
              [formName]="TechnicalSpecificationsFormSections.ExistingEnergyProducer"
              [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
              (lockButtonClickedEvent)="lockSection($event)"
              (unLockButtonClickedEvent)="unlockSection($event)"></lock-unlock-buttons>
            <i
              *ngIf="isDetailsView"
              class="pi pi-comment"
              [ngClass]="
                isExistingEnergyProducerCommentVisible ||
                technicalData.technical_specifications_sections_state?.existing_energy_producer_comment
                  ? 'lock-icon-style'
                  : 'unlock-icon-style'
              "
              [pTooltip]="
                (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                isExistingEnergyProducerCommentVisible ||
                technicalData.technical_specifications_sections_state?.existing_energy_producer_comment
                  ? ('comment-section.comment-tooltip' | translate)
                  : null
              "
              [tooltipPosition]="
                (isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles) ||
                isExistingEnergyProducerCommentVisible ||
                technicalData.technical_specifications_sections_state?.existing_energy_producer_comment
                  ? 'bottom'
                  : null
              "
              (click)="showComment(TechnicalSpecificationsFormSections.ExistingEnergyProducer)"></i>
          </div>
        </div>
      </div>
      <section-comment
        [isCommentTextInputVisible]="
          isModeratorRole() &&
          (isExistingEnergyProducerCommentVisible ||
            technicalData.technical_specifications_sections_state?.existing_energy_producer_comment)
        "
        [isCommentTextVisible]="role !== 'employee' && role !== 'administrator'"
        [isCommentSaveVisible]="!technicalData.technical_specifications_sections_state?.existing_energy_producer_comment"
        [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
        [comment]="technicalData.technical_specifications_sections_state?.existing_energy_producer_comment"
        [formName]="TechnicalSpecificationsFormSections.ExistingEnergyProducer"
        (saveCommentEvent)="updateComment($event)"
        (deleteCommentEvent)="deleteComment($event)"></section-comment>
      <div
        class="section-wrapper margin-align"
        [ngClass]="
          technicalData.technical_specifications_sections_state?.is_existing_energy_producer_locked !== true || !applicationId
            ? ''
            : 'disable-section'
        "
        *ngIf="technicalData.has_energy_producer === true">
        <div
          *ngFor="let existingProducer of technicalData.existing_energy_producers | slice : 1; index as i"
          class="top-bottom-margin bottom-border section-column">
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.producer-type' | translate }}
            </label>
            <p-dropdown
              class="form-control"
              [options]="typesOfEnergyProducers"
              [(ngModel)]="existingProducer.energy_type"
              (ngModelChange)="setEnergySource(existingProducer)"
              optionValue="value"
              placeholder="Please select"
              name="energy_type{{ i }}"
              [attr.data-testId]="'energy_type' + i"
              #energy_type{{i}}="ngModel"
              required
              [disabled]="isExistingEnergyProducerDisabled()"></p-dropdown>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.source-type' | translate }}
            </label>
            <p-dropdown
              class="form-control"
              [options]="getEnergySources(existingProducer)"
              [(ngModel)]="existingProducer.energy_source"
              optionValue="value"
              placeholder="Please select"
              name="energy_source{{ i }}"
              [attr.data-testId]="'energy_source' + i"
              #energy_source{{i}}="ngModel"
              required
              [disabled]="isExistingEnergyProducerDisabled()"></p-dropdown>
          </div>
          <div class="section-field">
            <label class="ui-g-5 required">
              {{ 'grid-comp.existing-producer-total-power' | translate }}
            </label>
            <p-inputNumber
              class="form-control"
              [(ngModel)]="existingProducer.total_feed_in_power"
              name="total_feed_in_power{{ i }}"
              #total_feed_in_power{{i}}="ngModel"
              mode="decimal"
              (keydown)="detectDecimalSeparator($event)"
              locale="de-DE"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
              required
              [disabled]="isExistingEnergyProducerDisabled()"></p-inputNumber>
            <label class="ml-2">kW</label>
          </div>
          <div
            *ngIf="existingProducer.energy_type === ENERGY_TYPES.OTHER || existingProducer.energy_source === ENERGY_SOURCES.OTHER"
            class="section-field">
            <label *ngIf="existingProducer.energy_type === ENERGY_TYPES.OTHER" class="ui-g-5 required">
              {{ 'grid-comp.other-producer' | translate }}
            </label>
            <input
              class="form-control"
              *ngIf="existingProducer.energy_type === ENERGY_TYPES.OTHER"
              type="text"
              pInputText
              [(ngModel)]="existingProducer.other_energy_type"
              name="other_energy_type{{ i }}"
              #other_energy_type{{i}}="ngModel"
              required
              [disabled]="isExistingEnergyProducerDisabled()" />
            <label *ngIf="existingProducer.energy_source === ENERGY_SOURCES.OTHER" class="ui-g-5 required">
              {{ 'grid-comp.other-source' | translate }}
            </label>
            <input
              class="form-control"
              *ngIf="existingProducer.energy_source === ENERGY_SOURCES.OTHER"
              type="text"
              pInputText
              [(ngModel)]="existingProducer.other_energy_source"
              name="other_energy_source{{ i }}"
              #other_energy_source{{i}}="ngModel"
              required
              [disabled]="isExistingEnergyProducerDisabled()" />
          </div>
          <div
            *ngIf="i > 0"
            (click)="removeElement(existingProducer, 'ExistingProducer')"
            class="pi pi-trash pointer-cursor right-aligned ui-g-11"
            [ngClass]="isExistingEnergyProducerDisabled() ? 'disable-section' : ''"></div>
        </div>

        <div class="section-field">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <div class="ui-g-12 add-button-row" [ngClass]="isExistingEnergyProducerDisabled() ? 'disable-section' : ''">
              <i
                (click)="addElement(technicalData.existing_energy_producers, 'ExistingProducer')"
                class="pi pi-plus plus-icon margin-zero"
                data-testId="add-energy-producer"
                tabindex="0"
                appEnterClick></i>
              <label class="field-label">
                {{ 'grid-comp.add-existing-producer' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- EXISTING ENERGY PRODUCER -optional -->

      <app-photovoltaics-data
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        [isIntegratedGridProtection]="isIntegratedGridProtection"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"
        (warningsVisible)="photovoltaicWarningsVisible($event)"></app-photovoltaics-data>

      <app-eproducer-data
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        [isIntegratedGridProtection]="isIntegratedGridProtection"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"
        (warningsVisible)="generatorWarningsVisible($event)"></app-eproducer-data>

      <app-storage-data
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        [isIntegratedGridProtection]="isIntegratedGridProtection"
        [powerStorageExists]="powerStorageExists"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"
        (warningsVisible)="storageWarningsVisible($event)"></app-storage-data>

      <app-power-plant-protection
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [isCentralGridProtection]="isCentralGridProtection"
        [isIntegratedGridProtection]="isIntegratedGridProtection"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"></app-power-plant-protection>

      <app-feed-in-type
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"></app-feed-in-type>

      <app-feed-in-controllability
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"></app-feed-in-controllability>

      <app-measurement-concept
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"></app-measurement-concept>

      <app-meter-operation
        [isDetailsView]="isDetailsView"
        [technicalData]="technicalData"
        [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
        [technicalForm]="technicalForm"
        [applicationId]="applicationId"
        (lockUnlockButtonClick)="isLockUnlockButtonClicked = true"></app-meter-operation>

      <app-order-history *ngIf="isDetailsView" [applicationId]="applicationId" [pagination]="true"></app-order-history>

      <div class="text-right-align top-margin send-message-section" *ngIf="isDetailsView">
        <button label="Download" pButton (click)="downloadAllDocuments()"></button>
      </div>

      <div class="ui-g-12 submit-button-section">
        <button
          data-testId="btn-save"
          *ngIf="isDetailsView"
          type="button"
          class="ui-button-save mr-3"
          (click)="saveFormData(false)"
          [disabled]="!(isTechnicalFormValid$ | async) || !((isTechnicalFormDirty$ | async) || isLockUnlockButtonClicked)"
          label="{{ 'grid-comp.save' | translate | uppercase }}"
          pButton></button>
        <button
          data-testId="btn-proceed"
          type="button"
          class="ui-button-proceed"
          (click)="saveFormData(true)"
          [disabled]="!(isTechnicalFormValid$ | async) || warningsVisible()"
          label="{{ 'grid-comp.proceed' | translate | uppercase }}"
          pButton></button>
      </div>
    </form>
  </div>
</div>
